import { create } from 'zustand';

import type { IUser } from "~/providers/interfaces";
import { USER } from "~/const";

interface IUserStore {
	user: IUser;
	// po nacteni stranky uz probehlo overeni prihlaseni (jwt), do te doby nevime, jestli je uzivatel prihlaseny
	authChecked: boolean;
	setAuthChecked: () => void;
	logout: () => void;
	login: (loginData: IUser) => void;
	update: (data: Partial<IUser>) => void;
}

export const userStore = create<IUserStore>(set => ({
	user: {
		...USER,
	},
	authChecked: false,
	setAuthChecked: () => set(() => ({
		authChecked: true,
	})),
	logout: () => set(() => ({
		user: {
			...USER,
		},
	})),
	login: loginData => set(() => ({
		user: {
			...loginData,
		},
	})),
	update: (data: Partial<IUser>) => set(state => ({
		user: {
			...state.user,
			...data,
		},
	})),
}));
